export default __webpack_public_path__ + "static/media/ic_guinea.dd9c2031.svg";